import React from 'react';
import { CollapsibleContentCard, Divider, SmallBody } from '@indigo-ag/component-module';
import { AgFinancing, CreditApprovalRound, DecisionSheet } from '@indigo-ag/schema';
import i18next from 'core/i18n';

import { CreditApprovalDetails } from './CreditApprovalDetails';
import { CreditApprovalEscalatedDetails } from './CreditApprovalEscalatedDetails';
import { CreditApprovalTimeline } from './CreditApprovalTimeline';
import { CreditApprovalExceptionsAndConditionals } from './CreditApprovalExceptionsAndConditionals';
import styled from 'styled-components';
import ImportedExceptionsConditionalsRedirect from './ImportedExceptionsConditionalsRedirect';

const CustomDivider = styled(Divider)`
  margin: 0.5rem 0;
`;

interface CreditApprovalProps {
  round?: CreditApprovalRound;
  additionalLimit: DecisionSheet['additionalLimit'];
  phase2?: AgFinancing['phase2'];
  importedExceptions?: string[];
  importedConditionals?: string[];
  parentId: string;
}

export const CreditApproval: React.FunctionComponent<CreditApprovalProps> = ({
  round,
  additionalLimit,
  phase2,
  importedExceptions = [],
  importedConditionals = [],
  parentId
}) => {
  const exceptionsAndConditionals = (
    <>
      <CreditApprovalExceptionsAndConditionals
        round={round}
        exceptionsAlreadyAdded={importedExceptions}
        conditionalsAlreadyAdded={importedConditionals}
        showHeaders
      />
      <ImportedExceptionsConditionalsRedirect
        exceptionsAlreadyAdded={importedExceptions}
        conditionalsAlreadyAdded={importedConditionals}
        parentId={parentId}
      />
    </>
  );

  return (
    <CollapsibleContentCard id="decision-sheet" titleText={'Credit Approval'}>
      {!round ? (
        <>
          <SmallBody>{i18next.t('creditApprovalNotStarted')}</SmallBody>
          <CustomDivider />
          {exceptionsAndConditionals}
        </>
      ) : (
        <>
          <CreditApprovalDetails
            additionalLimit={additionalLimit}
            tier={round?.creditThreshold?.tier}
            phase2={phase2}
          />
          <CreditApprovalEscalatedDetails phase2={phase2} />
          {exceptionsAndConditionals}
          <CreditApprovalTimeline steps={round?.steps || []} />
        </>
      )}
    </CollapsibleContentCard>
  );
};
